export const BOOTSTRAP_STATUS = 'Workspace listo' as const;

export function getBootstrapMessage(): string {
  return `InfraHub · ${BOOTSTRAP_STATUS}`;
}
